import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Radio from "components/atoms/Radio";

export const STYLE_TYPES = {
  FILTER_BOX: "filterbox",
};

export const NO_VALUE = undefined;

const RadioGroup = ({
  name,
  styleType = STYLE_TYPES.FILTER_BOX,
  selectedValue = NO_VALUE,
  resetOnRadioClick = false,
  onValueChange,
  radios = [],
}) => {
  const [isNavigatingWithArrows, setIsNavigatingWithArrows] = useState(false);
  const handleRadioChange = (e) => {
    // prevent value change on navigation with arrow up and arrow down
    if (!isNavigatingWithArrows) {
      const { value, checked } = e.target;
      const newValue = checked ? value : NO_VALUE;
      onValueChange({ name, value: newValue });
    }
    setIsNavigatingWithArrows(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      setIsNavigatingWithArrows(true);
    } else if (e.key === "Enter") {
      // dispatch click event
      e.target.click();
    }
  };

  const handleRadioClick = (e) => {
    if (!resetOnRadioClick) return;

    const { value, checked } = e.target;
    if (checked && selectedValue === value) {
      handleRadioChange({
        target: {
          checked: false,
        },
      });
    }
  };

  const componentClassName = "sal-radiogroup";
  const classNames = classnames(
    componentClassName,
    `${componentClassName}--${styleType}`,
  );

  const radioList = radios.map((radio, index) => {
    const isActive = radio.value === selectedValue;
    const itemClassName = `${componentClassName}__item`;
    const itemClassNames = classnames(itemClassName, {
      [`${itemClassName}--active`]: isActive,
    });

    return (
      <li key={`radio-${index}`} className={itemClassNames}>
        <Radio
          {...radio}
          name={name}
          checked={isActive}
          onChange={handleRadioChange}
          onKeyDown={handleKeyDown}
          onClick={handleRadioClick}
        />
      </li>
    );
  });

  return (
    <ul className={classNames} role="radiogroup" aria-label={name}>
      {radioList}
    </ul>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  styleType: PropTypes.oneOf(
    Object.keys(STYLE_TYPES).map((k) => STYLE_TYPES[k]),
  ),
  selectedValue: PropTypes.string,
  resetOnRadioClick: PropTypes.bool,
  onValueChange: PropTypes.func.isRequired,
  radios: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.node,
    }),
  ),
};

export default RadioGroup;
